export default function getApiHost() {
  if (process.env.NODE_ENV === 'production') {
    const firstSubdomain = window.location.hostname.split('.')[0]
    const isLocalhost = window.location.hostname === 'localhost'
    const apiHostName = window.location.hostname.replace(firstSubdomain, 'core')
    return isLocalhost ? process.env.VUE_APP_DEV_API_HOST : `${window.location.protocol}//${apiHostName}`
  }
  return process.env.VUE_APP_DEV_API_HOST
}
